import teams from './teams.js';
import trials from './trials.js';
import stages from './stages.js';
import participants from './participants.js';
import responses from './responses.js';

const actions = { teams, trials, stages, participants, responses };
export default actions;
